import { FC } from "react";
import { CustomDropdown, HealthFactorCircle } from "../..";
import { IconEthereum } from "../../icons";

type Props = {
  className?: string;
};

export const EmptyLoan: FC<Props> = () => {
  return (
    <tr className="bg-secondary hover:bg-primary/10 text-base font-medium">
      <td scope="row" className="flex items-center gap-3 py-4 px-3 font-medium">
        <div className="w-16 flex items-center justify-center">
          <div className="w-16 h-16 border-2 border-dashed rounded-xl"></div>
        </div>
      </td>

      <td className="px-3 font-bold">---</td>
      <td className="px-3 items-center">
        <div className="flex gap-x-2 items-center">
          ----
          <div className="bg-white w-5 h-5 rounded-full mt-0.3">
            <IconEthereum />
          </div>
        </div>
      </td>
      <td className="px-3">
        <div className="flex gap-x-2 items-center">
          ----
          <div className="bg-white w-5 h-5 rounded-full">
            <IconEthereum />
          </div>
        </div>
      </td>
      <td className="py-4 px-3">
        <div className="flex items-center gap-1.5">
          <p>---</p>
          <HealthFactorCircle />
        </div>
      </td>
      <td className="py-4 px-3">
        <div className="relative sm:max-w-xl sm:mx-auto mt-0.5">
          <div className="group flex relative border-gray-400 text-center">
            <div className="flex gap-x-2 items-center">
              ----
              <div className="bg-white w-5 h-5 rounded-full">
                <IconEthereum />
              </div>
            </div>
            <div className="opacity-0 max-w-max ml-14 mb-2 bg-secondary text-white border border-white text-center text-xs rounded-lg py-2 absolute z-10 group-hover:opacity-100 bottom-full -left-1/2 px-3 pointer-events-none">
              ----
            </div>
          </div>
        </div>
      </td>
      <td className="px-3">
        <div className="flex gap-x-2 items-center">
          ----
          <div className="bg-white w-5 h-5 rounded-full">
            <IconEthereum />
          </div>
        </div>
      </td>
      <td></td>
      <td className="px-3">
        <CustomDropdown
          className="w-40"
          label="Manage"
          options={[]}
          disabled={true}
        />
      </td>
    </tr>
  );
};
